import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import NavBar2 from '../../components/NavBar2';

const OtpForm = ( { setShowOtp, email } ) => {
  const [otp, setOtp] = useState('');
  const [message, setMessage] = useState('');
  const [buttonEnabled, setButtonEnabled] = useState(false);
  const [countdown, setCountdown] = useState();
  const [isVerifying, setIsVerifying] = useState(false); // New state for verify button loading
  const [isResending, setIsResending] = useState(false); // New state for resend button loading
  const navigate = useNavigate();

  const enableResend = () => {
    setButtonEnabled(false);
    setCountdown(30); // Reset countdown timer

    const timer = setInterval(() => {
      setCountdown(prevCountdown => prevCountdown - 1);
    }, 1000); // Update countdown every second

    // // Enable the button after countdown finishes
    setTimeout(() => {
      clearInterval(timer);
      setButtonEnabled(true);
    }, 30000);
  };
  
  useEffect(() => {
    enableResend();
  }, []);

  const resend = async () => {
    setIsResending(true); // Disable resend button
    enableResend(); // Start countdown and disable button
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/resend-otp`, {
        email: email,
      });
      setMessage(response.data.message);
    } catch (error) {
      if (error.response) {
        setMessage(error.response.data.message || 'Something went wrong');
      } else if (error.request) {
        setMessage('No response from server. Please try again later.');
      } else {
        setMessage('Failed to resend OTP. Please try again later.');
      }
    } finally {
      setIsResending(false); // Ensure button is re-enabled even on error
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsVerifying(true); // Disable verify button

    try {
      // Send the data to the API
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/verify-otp`, {
        email,
        otp, // Send OTP to the server
      });

      setMessage(response.data.message);
      localStorage.setItem('userEmail', email);
      localStorage.setItem('token', response.data.token);
      window.location.reload();
    } catch (error) {
      // Handle error
      console.error('OTP verification failed:', error.response.data.message);
      setMessage(error.response.data.message)
    } finally {
      setIsVerifying(false); // Ensure button is re-enabled even on error
    }
  };

  return (
    <div>
      <NavBar2 />
      <div className="min-h-screen flex md:items-center justify-center pt-20 bg-white md:bg-gray-100">
        <div className="bg-white p-6 rounded md:shadow-md w-full max-w-md ">
          <h2 className="text-2xl font-semibold mb-4">Verify your email</h2>
          <p className="text-lg mb-4">Enter 6 digits OTP sent to {email}:</p>
          <button className="text-md text-black underline mb-4" onClick={() => setShowOtp(false)}>Change email? Click here!</button>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-700">OTP:</label>
              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder='XXXXXX'
                className="w-full border rounded py-2 px-3 focus:outline-none focus:ring focus:border-blue-300"
                required
              />
            </div>
            <p className='my-4 text-red-500'>{message}</p>
            <div className='flex space-x-2'>
              <button
                type="submit"
                className="btn-primary focus:outline-none focus:ring focus:border-red-300"
                disabled={isVerifying} // Disable button while verifying
              >
                {isVerifying ? 'Verifying...' : 'Verify'}
              </button>
            </div>
          </form>
          <button
            className={`${buttonEnabled && !isResending ? 'bg-button1 hover:bg-button1 focus:border-button1' : 'bg-gray-400 hover:bg-gray-500 focus:border-gray-300'} mt-4 text-white py-2 px-4 rounded focus:outline-none focus:ring`}
            onClick={resend} 
            disabled={!buttonEnabled || isResending} // Disable button while resending or countdown is active
          >
            {isResending ? 'Resending...' : (buttonEnabled ? 'Resend OTP' : `Resend OTP (${countdown})`)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OtpForm;
